import {useDispatch, useSelector} from "react-redux";
import React, {useEffect, useState} from "react";
import {setCreateButton, setTitle} from "../actions/main";
import Loader from "../components/Loader";
import {EventsService} from "../services/EventsService";
import formater from "../helpers/formater";
import {CashService} from "../services/CashService";
import {Link} from "react-router-dom";
import {Calendar} from "primereact/calendar";
import {Dialog} from "primereact/dialog";
import {Button} from "primereact/button";
import {Checkbox} from "primereact/checkbox";
import Formater from "../helpers/formater";

function Analyz() {

    const dispatch = useDispatch()
    const [loading, setLoading] = useState(true)
    const [date, setDate] = useState(() => {
        if (localStorage.getItem('analyz_date')) {
            // console.log('tttttime', localStorage.getItem('events_date'))
            // console.log('aaaaaaaa', new Date(parseInt(localStorage.getItem('events_date'))))
            return new Date(parseInt(localStorage.getItem('analyz_date')))
        } else {
            return new Date()
        }
    })
    const currentDepartment = useSelector(function (state) {
        return state.currentDepartment
    });
    const [events, setEvents] = useState(false)
    const [receipt, setReceipt] = useState(false)
    const [dialogVisible, setDialogVisible] = useState(false)
    const [exportDialogVisible, setExportDialogVisible] = useState(false)
    const [currentEvent, setCurrentEvent] = useState(false)


    const updateData = (params) => {
        EventsService.GetList({filter: {client_id: currentDepartment}}).then((res) => {
            let arr = []
            res.items.map((el) => {
                console.log(new Date(el.date).getMonth())
                // console.log(date.getMonth())
                console.log(new Date(el.date).getFullYear())
                // console.log(date.getFullYear())
                if (new Date(el.date).getMonth() === date.getMonth() && new Date(el.date).getFullYear() === date.getFullYear()) {
                    arr.push(el)
                }
            })
            setEvents(arr)
            setLoading(false)
        })
        CashService.GetList({client_id: currentDepartment, limit: 10000}).then((res) => {
            setReceipt(res.items)
            setLoading(false)
        })
    }

    useEffect(() => {
        setLoading(true)
        dispatch(setTitle(''))
        // dispatch()
        dispatch(setCreateButton(false))
        updateData()

        if (date) {
            localStorage.setItem('analyz_date', date.getTime())
        }
    }, [currentDepartment, date]);

    const eventFee = (event) => {
        if (event.artist_fee_correct) {
            return formater.amountFormat(event.artist_fee_correct)
        }
        if (event.artist_fee_type === 2) {
            return event.artist_fee + '%'
        } else {
            return formater.amountFormat(event.artist_fee)
        }
    }
    const eventFeePlan = (event, withCorrect = false) => {

        if (withCorrect && event.artist_fee_correct) {
            return event.artist_fee_correct
        }

        if (event.artist_fee_type === 2) {
            return ticketAmount(event) / 100 * event.artist_fee
        } else {
            return event.artist_fee
        }
    }
    const eventFeeAmount = (event) => {
        if (event.artist_fee_correct) {
            return event.artist_fee_correct || 0
        }
        if (event.artist_fee_type === 2) {
            const fee = event.artist_fee || 0;
            return ticketAmount(event) / 100 * fee
        } else {
            return event.artist_fee || 0
        }
    }

    // Отдел операции совпадает с текущим (пустой отдел у операции или на странице = подходит всем)
    const sameDept = (r) => currentDepartment === null || currentDepartment === undefined || currentDepartment === ''
        || r.client_id === null || r.client_id === undefined || Number(r.client_id) === Number(currentDepartment)

    const ticketAmount = (event) => {
        let am = 0
        if (receipt) {
            receipt.filter((r) => sameDept(r) && r.event_id === event.id && !r.is_cost).map((r) => {
                am += r.amount
            })
        }
        return am
    }
    const ticketAmountBlack = (event) => {
        let am = 0
        if (receipt) {
            receipt.filter((r) => sameDept(r) && r.event_id === event.id && !r.is_cost && r.type === 'rub').map((r) => {
                am += r.amount
            })
        }
        return am
    }

    const rao = (event) => {
        return ticketAmount(event) / 100 * 5
    }

    const maxFee = (event) => {
        let am = 0
        let f = 0
        if (receipt) {
            receipt.filter((r) => sameDept(r) && r.event_id === event.id && !r.is_cost && (r.type === 'card_5' || r.type === 'credit_5')).map((r) => {
                am += r.amount
            })
        }

        if (am > 0) {
            f += am / 100 * 11;
        }

        return f
    }

    const minFee = (event) => {
        let am = 0
        let f = 0

        if (receipt) {
            receipt.filter((r) => sameDept(r) && r.event_id === event.id && !r.is_cost && (r.type === 'credit' || r.type === 'card')).map((r) => {
                am += r.amount
            })
        }

        if (am > 0) {
            f += am / 100 * 6;
            am = 0
        }

        return f
    }

    const fee = (event) => {
        return maxFee(event) + minFee(event)
    }


    const prevMonthHandler = (e) => {
        const d = new Date(JSON.parse(JSON.stringify(date)));
        d.setMonth(d.getMonth() - 1)
        setDate(d)
    }
    const nextMonthHandler = (e) => {
        const d = new Date(JSON.parse(JSON.stringify(date)));
        d.setMonth(d.getMonth() + 1)
        setDate(d)
    }

    const dohod = (event) => {
        if (event.is_canceled) {
            return (event.canceled_amount || 0) * -1
        }
        // Handle null/undefined values as 0 to prevent calculation errors
        const raiderB = event.raider_b || 0;
        const raiderT = event.raider_t || 0;
        const sound = event.sound || 0;
        const rao = event.rao || 0;
        const advFact = event.adv_fact || 0;
        
        return ticketAmount(event) - eventFeeAmount(event) - raiderB - raiderT - fee(event) - sound - rao - advFact
    }

    const handleScroll = (e) => {
        // if(!loading) {
        localStorage.setItem('analyz_scroll', window.pageYOffset)
        // }
    }

    useEffect(() => {
        // alert(localStorage.getItem('events_scroll'))
        if (localStorage.getItem('analyz_scroll')) {
            window.scrollTo({top: parseInt(localStorage.getItem('analyz_scroll')), behavior: "smooth"});
        }
    }, [events]);


    useEffect(() => {
        window.addEventListener('scroll', handleScroll, true);
        // Remove listener when component unmounts
        // window.removeEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll, true);
        }
    }, [])

    let dohodSumm = 0
    let gonorSumm = 0
    let gonorFactSumm = 0
    let tickets = 0
    let b_raider = 0
    let t_raider = 0
    let rest = 0
    let restKitchen = 0
    let restBar = 0

    const moreFields = [
        'Гонора артиста',
        'Гонора артиста (корректировка)',
        'Билеты выручка (общая)',
        'Билеты выручка (без чека)',
        'Кол-во билетов',
        'Средний чек билеты',
        'Сумма гонорара артиста',
        'Сумма гонорара',
        'РАО (5% от выручки)',
        'РАО (корректировка)',
        'Бытовой райдер',
        'Технический райдер',
        'Налог 6%',
        'Налог 11%',
        // 'Общий налог',
        'Свет и звук',
        'Билеты доход',
        // 'Билеты доход (новое)',
        'Ресторан',
        'Средний чек ресторана',
        'План реклама',
        'Факт реклама',
    ]

    const [moreFieldsSelected, setMoreFieldsSelected] = useState(moreFields)

    const getEventFieldValue = (currentEvent, field) => {
        let v
        switch (field) {
            case 'Гонора артиста':
                v = formater.amountFormat(eventFeePlan(currentEvent)) + (currentEvent.artist_fee_type === 2 ? '(' + currentEvent.artist_fee + '%)' : '');
                break;
            case 'Гонора артиста (корректировка)':
                v = formater.amountFormat(currentEvent.artist_fee_correct);
                break;
            case 'Билеты выручка (общая)':
                v = formater.amountFormat(ticketAmount(currentEvent))
                break;
            case 'Билеты выручка (без чека)':
                v = formater.amountFormat(ticketAmountBlack(currentEvent))
                break;
            case 'Кол-во билетов':
                v = currentEvent.ticket_sale
                break;
            case 'Средний чек билеты':
                v = formater.amountFormat(ticketAmount(currentEvent) / currentEvent.ticket_sale)
                break;
            case 'Сумма гонорара артиста':
                v = formater.amountFormat(eventFeeAmount(currentEvent))
                break;
            case 'Сумма гонорара':
                v = formater.amountFormat(ticketAmount(currentEvent) - eventFeeAmount(currentEvent))
                break;
            case 'РАО (5% от выручки)':
                v = formater.amountFormat(rao(currentEvent))
                break;
            case 'РАО (корректировка)':
                v = formater.amountFormat(currentEvent.rao)
                break;
            case 'Бытовой райдер':
                v = formater.amountFormat(currentEvent.raider_b)
                break;
            case 'Технический райдер':
                v = formater.amountFormat(currentEvent.raider_t)
                break;
            case 'Налог 6%':
                v = formater.amountFormat(minFee(currentEvent))
                if (minFee(currentEvent) === 0) {
                    return false;
                }
                break;
            case 'Налог 11%':
                v = formater.amountFormat(maxFee(currentEvent))
                if (maxFee(currentEvent) === 0) {
                    return false;
                }
                break;
            case 'Общий налог':
                v = formater.amountFormat(fee(currentEvent))
                break;
            case 'Свет и звук':
                v = formater.amountFormat(currentEvent.sound)
                break;
            case 'Билеты доход':
                v = formater.amountFormat(ticketAmount(currentEvent) - eventFeeAmount(currentEvent) - currentEvent.raider_b - currentEvent.raider_t - fee(currentEvent) - currentEvent.sound - currentEvent.rao - (currentEvent.adv_fact || 0))
                break;
            case 'Билеты доход (новое)':
                v = formater.amountFormat(ticketAmount(currentEvent) - eventFeeAmount(currentEvent) - fee(currentEvent) - currentEvent.sound - currentEvent.rao)
                break;
            case 'Ресторан':
                v = formater.amountFormat(currentEvent.restaurant)
                break;
            case 'Средний чек ресторана':
                v = formater.amountFormat(currentEvent.restaurant / currentEvent.ticket_sale)
                break;
            case 'План реклама':
                v = formater.amountFormat(currentEvent.adv_plan)
                break;
            case 'Факт реклама':
                v = formater.amountFormat(currentEvent.adv_fact)
                break;
        }
        return v
    }

    const getExportData = () => {
        let data = []
        events.map((event) => {
            let eventData = {

                'Дата': new Date(event.date).toLocaleDateString(),
                'Название концерта': event.name
            }
            moreFieldsSelected.map((field) => {
                eventData[field] = getEventFieldValue(event, field)
            })
            data.push(eventData)
        })
        console.log(data)
        exportToCSV(data)

        // var form = document.createElement('form');
        // document.body.appendChild(form);
        // form.method = 'post';
        // form.action = 'http://yii2.easytickets.pro/site/export';
        // for (var name in data) {
        //     var input = document.createElement('input');
        //     input.type = 'hidden';
        //     input.name = name;
        //     input.value = JSON.stringify(data[name]);
        //     form.appendChild(input);
        // }
        // form.submit();
    }

    const objectToCSVRow = function (dataObject) {
        var dataArray = new Array;
        for (var o in dataObject) {
            var innerValue = dataObject[o] === null ? '' : dataObject[o].toString();
            var result = innerValue.replace(/"/g, '""');
            result = '"' + result + '"';
            dataArray.push(result);
        }
        return dataArray.join(',') + '\r\n';
    }

    const exportToCSV = function (arrayOfObjects) {

        if (!arrayOfObjects.length) {
            return;
        }

        var csvContent = "data:text/csv;charset=utf-8,";

        // headers
        csvContent += objectToCSVRow(Object.keys(arrayOfObjects[0]));

        arrayOfObjects.forEach(function (item) {
            csvContent += objectToCSVRow(item);
        });

        var encodedUri = encodeURI(csvContent);
        var link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", "Анализ_" + (Formater.MonthShortName(date.getMonth())) + "_" + date.getFullYear() + ".csv");
        document.body.appendChild(link); // Required for FF
        link.click();
        document.body.removeChild(link);
    }


    return (
        <>

            <div className="d-flex align-items-center justify-content-between p-t-10">
                <h1>{'Анализ'}</h1>

                <div className={'d-flex gap-5'}>

                    <Button icon={'pi pi-file-export'} className={'p-button-text'} label={'Экспорт'} text
                            onClick={() => setExportDialogVisible(true)}/>

                    <div className={'d-flex gap-2 flex-shrink-0 justify-content-end p-button-group'}>
                        <Button icon={'pi pi-angle-left'} text severity="secondary"
                                onClick={(e) => prevMonthHandler()}/>

                        <Calendar
                            inputClassName={' p-component p-button-secondary p-button p-button-text'}
                            value={date} onChange={(e) => setDate(e.value)} view="month"
                            dateFormat="MM yy"/>

                        <Button icon={'pi pi-angle-right'} text severity={'secondary'}
                                onClick={(e) => nextMonthHandler()}/>
                    </div>

                </div>
            </div>
            {/*<Calendar selectionMode={'range'} readOnlyInput={true} numberOfMonths={3} />*/}

            <div className="card">
                <div className="card-body">
                    <div className="table-responsive">
                        {loading && <Loader/>}

                        <Dialog header={() => {
                            return <>Выберите поля</>
                        }} style={{'width': '500px'}} onHide={() => setExportDialogVisible(false)}
                                visible={exportDialogVisible} footer={() => {
                            return (
                                <Button label={'Скачать'} className={'p-button-text'} icon={'pi pi-file-export'} text
                                        onClick={() => {
                                            getExportData()
                                            setExportDialogVisible(false)
                                        }}/>
                            )
                        }}>
                            <div className={'d-flex flex-column gap-3'}>

                                {moreFields.map((field, k) => {
                                    return <div className={'d-flex gap-3 align-items-center'}><Checkbox
                                        inputId={'export-field-' + k} value={field}
                                        checked={moreFieldsSelected.includes(field)} onChange={(e) => {
                                        let newData = []
                                        if (e.checked) {
                                            newData = [...moreFieldsSelected, e.value]
                                            setMoreFieldsSelected(newData)
                                        } else {
                                            newData = JSON.parse(JSON.stringify(moreFieldsSelected))

                                            newData.splice(newData.indexOf(e.value), 1)
                                            setMoreFieldsSelected(newData)
                                        }
                                        console.log(newData)
                                    }}></Checkbox><label htmlFor={'export-field-' + k}
                                                         className={'p-checkbox-label mb-0 pb-0'}>{field}</label></div>
                                })}
                            </div>


                        </Dialog>


                        <Dialog header={currentEvent.name + ' ' + new Date(currentEvent.date).toLocaleDateString()}
                                onHide={() => setDialogVisible(false)} visible={dialogVisible}
                                style={{'width': '50vw'}}>

                            <table className={'w-100 table-bordered'}>
                                {moreFields.map((field) => {
                                    if (getEventFieldValue(currentEvent, field) !== false) {

                                        return (
                                            <tr>
                                                <th>{field}</th>
                                                <td>{getEventFieldValue(currentEvent, field)}</td>
                                            </tr>
                                        )
                                    }
                                })}
                            </table>

                        </Dialog>
                        <table className={'table table-styling artists-table'} style={{'white-space': 'nowrap'}}>
                            <thead>
                            <tr>
                                <th>Дата</th>
                                <th>Название концерта</th>
                                <th>Гонор. план.</th>
                                <th>Гонор. факт.</th>
                                {/*<th>Билеты выручка (общая)</th>*/}
                                {/*<th>Билеты выручка (без чека)</th>*/}
                                <th>Билетов</th>
                                {/*<th>Средний чек билеты</th>*/}
                                {/*<th>Сумма гонорара артиста</th>*/}
                                {/*<th>Сумма гонорара</th>*/}
                                {/*<th>РАО</th>*/}
                                <th>Б. райдер</th>
                                <th>Т. райдер</th>
                                {/*<th>Налог</th>*/}
                                {/*<th>Свет и звук</th>*/}
                                <th>Доход</th>
                                <th>Ресторан</th>
                                <th>Кухня</th>
                                <th>Бар</th>
                                <th></th>
                                {/*<th>Средний чек ресторана</th>*/}
                                {/*<th>Реклама</th>*/}
                            </tr>
                            </thead>
                            <tbody>

                            {events && events.map((event) => {

                                dohodSumm += dohod(event)
                                gonorSumm += eventFeePlan(event)
                                gonorFactSumm += eventFeePlan(event, true)
                                tickets += event.ticket_sale
                                b_raider += event.raider_b
                                t_raider += event.raider_t
                                rest += event.restaurant
                                restKitchen += event.restaurant_kitchen || 0
                                restBar += event.restaurant_bar || 0

                                return (
                                    <tr className={' ' + (event.is_canceled ? 'canceled' : '')}>
                                        <td>{new Date(event.date).toLocaleDateString()}</td>
                                        <td><Link to={'/event/' + event.id}>{event.name}</Link></td>
                                        <td>{formater.amountFormat(eventFeePlan(event))} {event.artist_fee_type === 2 ? '(' + event.artist_fee + '%)' : ''}</td>
                                        <td>{eventFee(event)}</td>
                                        {/*<td>{formater.amountFormat(ticketAmount(event))}</td>*/}
                                        {/*<td>{formater.amountFormat(ticketAmountBlack(event))}</td>*/}
                                        <td>{event.ticket_sale}</td>
                                        {/*<td>{formater.amountFormat(ticketAmount(event)/event.ticket_sale)}</td>*/}
                                        {/*<td>{formater.amountFormat(eventFeeAmount(event))}</td>*/}
                                        {/*<td>{formater.amountFormat(ticketAmount(event) - eventFeeAmount(event))}</td>*/}
                                        {/*<td>{formater.amountFormat(rao(event))}</td>*/}
                                        <td>{formater.amountFormat(event.raider_b)}</td>
                                        <td>{formater.amountFormat(event.raider_t)}</td>
                                        {/*<td>{formater.amountFormat(event.raider_t)}</td>*/}
                                        {/*<td>{formater.amountFormat(fee(event))}</td>*/}
                                        {/*<td>{formater.amountFormat(event.sound)}</td>*/}
                                        <td className={dohod(event) < 0 ? 'cash-cost' : ''}>{formater.amountFormat(dohod(event))}</td>
                                        <td>{formater.amountFormat(event.restaurant)}</td>
                                        <td>{event.restaurant_kitchen != null ? formater.amountFormat(event.restaurant_kitchen) : '—'}</td>
                                        <td>{event.restaurant_bar != null ? formater.amountFormat(event.restaurant_bar) : '—'}</td>
                                        {/*<td>{formater.amountFormat(event.restaurant/event.ticket_sale)}</td>*/}
                                        {/*<td>{formater.amountFormat(event.adv)}</td>*/}
                                        <td>
                                            <a href="#" onClick={(e) => {
                                                setCurrentEvent(event)
                                                setDialogVisible(true)
                                            }}>Подробнее</a>
                                        </td>
                                    </tr>
                                )
                            })}
                            </tbody>
                            <tfoot>
                            <tr>
                                <th>
                                    <strong>Итого</strong>
                                </th>
                                <th></th>
                                <th>{formater.amountFormat(gonorSumm)}</th>
                                <th>{formater.amountFormat(gonorFactSumm)}</th>
                                <th>{tickets}</th>
                                <th>{formater.amountFormat(b_raider)}</th>
                                <th>{formater.amountFormat(t_raider)}</th>
                                <th className={dohodSumm < 0 ? 'cash-cost' : 'cash-enrollment'}>
                                    {formater.amountFormat(dohodSumm)}
                                </th>
                                <th>{formater.amountFormat(rest)}</th>
                                <th>{formater.amountFormat(restKitchen)}</th>
                                <th>{formater.amountFormat(restBar)}</th>
                                <th></th>
                            </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>

        </>
    )
}

export default Analyz